/**
 * https://www.pdftron.com/api/web/Core.Document.html#getPageInfo__anchor
 */
export default pageNumber => window.documentViewer.getDocument().getPageInfo(pageNumber);
